import React, {Component} from 'react';
import App from "../../App";
import {Link, withRouter} from "react-router-dom";
import {MdArrowBack} from "react-icons/all";
import { getDetails, getPaginatedList, postData } from "../../services/baseServices";
import {toast} from "react-toastify";
import PartnerList from './PartnerList';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Button} from "react-bootstrap";
import _ from 'lodash'
import { DEBOUNCE_TIME } from "../../helper/env"
import {humanize} from '../../helper/utils'

class Details extends Component {
	constructor(){
        super();

		var d = localStorage.getItem("sr_margin_date") ? new Date(localStorage.getItem("sr_margin_date")): new Date();
		var schedule = localStorage.getItem("sr_margin_schedule") ? localStorage.getItem("sr_margin_schedule") : "sat_sun_mon_tues_wed_thurs";

		this.state = {
			routeInfo: {},
			partnerInfo:{},
			amount:0,
			isLoading: true,
			activePage: 1,
			per_page: 20,
			page: 1,
			counter: 1,
			partner_schedule: schedule,
			showPaymentModal:false,
			paymentKey:'',
			submitting: false,
			startDate: d,
		};
	}
	

	getData() {
        const params = {
			month : this.state.startDate?.getMonth() + 1,
			year: this.state.startDate?.getFullYear(),
			partner_schedule: this.state?.partner_schedule

		};
		this.setState({isLoading: true});
        getPaginatedList(`routes/${this.props.match.params.id}/partner_margins`, params)
        .then((res) => {
		
            this.setState({
                partnerInfo: res?.data?.data,
                counter:
                    this.state.activePage - 1 > 0
                        ? (this.state.activePage - 1) * this.state.per_page + 1
                        : 1,
                per_page: res.headers["x-per-page"],
                total_data: res.headers["x-total"],
                isLoading: false,
            });
        })
        .catch((err) => {
                this.setState({isLoading: false})
				toast.error(err.messsage)
            });
	}

	componentDidMount() {
		this.getData();
		getDetails("routes", this.props.match.params.id)
		.then(res => {
			this.setState({ routeInfo: res?.data });
		})
		.catch(errMsg => {
			console.log('Err Msg: ', errMsg)
		});
	}

	debouncedOnPay = _.debounce(()=>{
		this.handleSubmitPayment()
	}, DEBOUNCE_TIME);
	
	handleWithDebouncePayment = () => {
		this.debouncedOnPay();
	}

    handleSubmitPayment = () =>{
		this.setState({submitting: true})
		const params = {
			route_id : this.props.match.params.id,
			amount:  Math.ceil(this.state.amount),
			month : this.state.startDate?.getMonth() + 1,
			year: this.state.startDate?.getFullYear(),
			partner_schedule: this.state?.partner_schedule,
		}
        postData('route_margins/pay',params)
            .then(res =>{
                if(res.success){
                    toast.success(res.message)
					this.getData()
                }else{
                    toast.error(res.message)
                }
            })
            .catch(err =>{
                toast.error('Something went wrong')
            })
    }

	handleFilterOnChange = (e) => {
        this.setState({partner_schedule:e.target.value});
    };

    filterList = (e) => {
        e.preventDefault();
		localStorage.setItem('sr_margin_date', this.state.startDate)
		localStorage.setItem('sr_margin_schedule', this.state.partner_schedule)
		this.setState({activePage: 1});
        this.getData();
    };

	render() {

		return (
			<App layout={`boxed`}>
				<div className="main-content">
					<div className="page-header">
						<div className="page-title"/>
						<div className="ml-auto">
						<Link 
							to={`${process.env.PUBLIC_URL}/srMargin/list`} 
							className={`btn btn-sm btn-link`}
						>
							<MdArrowBack/> Back to List
						</Link>
						</div>
					</div>

					<div className="card-block">
						<div className="block-header">
						<h4 className="block-title">SR Details</h4>
						</div>
						<div className="block-body">
							<table className="info-table">
								<tbody>
									<tr>
										<td style={{width: '100px'}}>Title : </td>
										<td>:</td>
										<td>{this.state.routeInfo.title}</td>
									</tr>
									<tr>
										<td style={{width: '100px'}}>SR Name : </td>
										<td>:</td>
										<td>{this.state.routeInfo.sr_name}</td>
									</tr>
									<tr>
										<td style={{width: '100px'}}>Phone : </td>
										<td>:</td>
										<td>{this.state.routeInfo.phone}</td>
									</tr>
									<tr>
										<td style={{width: '100px'}}>SR Point </td>
										<td>:</td>
										<td >{this.state.routeInfo.sr_point}</td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
				</div>
				<div>
				<form className="form-inline mb-3">
                        <div className="form-group mr-3">
                            <select
                                id="section"
                                name="section"
                                className="form-control form-control-sm"
                                onChange={this.handleFilterOnChange}
                                value={this.state?.partner_schedule}
                            >
                                <option value="">--Select section Date--</option>
                                <option value="sat_mon_wed">SAT-MON-WED</option>
                                <option value="sun_tues_thurs">SUN-TUE-THURS</option>
                                <option value="sat_sun_mon_tues_wed_thurs">
                                    SAT-SUN-MON-TUE-WED-THURS
                                </option>
                            </select>
                        </div>
                        <div className="form-group mr-3">
						<DatePicker
							selected={this.state.startDate}
							onChange={(date) => this.setState({startDate:date})} 
							dateFormat="MMMM-yyyy"
							className='datePicker'
							showMonthYearPicker 
							placeholderText="--Select month & year--"
							/>
						
						</div>
                        
                        <Button
                            size="sm"
                            type={`submit`}
							disabled={ (!this.state.partner_schedule  || !this.state.startDate)}
                            onClick={this.filterList}
                            variant="primary"
                        >
                            Search
                        </Button>
                </form>

				{ 
					Object.keys(this.state.partnerInfo).length > 0 && (
						<>
							<div className="card-block">
								<div className="block-body">
									<table className="table table-bordered table-striped">
										<thead>
											<tr >
												<th className='text-center'> Total Amount</th>
												<th className='text-center'>Pay Status</th>												
												{/* <th className='text-center'>Action</th> */}
											</tr>
										</thead>
										<tbody>
											<tr>
												<td className='text-center'> {this.state.partnerInfo.partner_info.total_payment}</td>

												<td className='text-center'>
													{humanize(this.state.partnerInfo.pay_status)}
												</td>
												{/* <td className='text-center'>
													
													{

														
														(this.state.partnerInfo.pay_status === "pending"
															&& this.state.partnerInfo.partner_info.total_payment > 0) ?
															<OverlayTrigger
																key="view"
																placement="top"
																overlay={
																	<Tooltip id={`tooltip-view`}>
																	Pay
																	</Tooltip>
																}
																>
																<ConfirmationModal title="Pay to SR" body="Are you sure to pay?" 
																	customBtn = {true}
																	variant = {"primary"}
																	btnText="Pay"
																handleAction={() =>this.handleWithDebouncePayment()}/>
															</OverlayTrigger>
															:
															<button className='btn btn-sm btn-primary' disabled>
																Pay
															</button>
													}
													
												</td> */}
											</tr>
										</tbody>
									</table>			
							</div>
							</div>
							<PartnerList partner_list={this.state.partnerInfo?.partner_info.details_list} date = {this.state.startDate}/>

						</>
					)
				}
				
			</div>
				
			</App>
		);
	}	
}

export default withRouter(Details);